var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511 452.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4f1e9;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke: #2b463c;\n        stroke-width: 2px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-8 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-9 {\n        fill: #2b463c;\n      }\n\n      .cls-3 {\n        fill: #d3c7af;\n      }\n\n      .cls-4, .cls-10 {\n        fill: #b1d184;\n      }\n\n      .cls-5 {\n        fill: #b1cf84;\n      }\n\n      .cls-6, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-6, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-7 {\n        stroke-linejoin: round;\n      }\n\n      .cls-9, .cls-10 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 213.63,
    y: 175.29,
    width: 27.31,
    height: 27.31,
    transform: "translate(-37.14 56.89) rotate(-13.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 434.77,
    y: 168.9,
    width: 27.31,
    height: 27.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 343.25,
    y: 310.65,
    width: 27.31,
    height: 27.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 215.84,
    y: 172.31,
    width: 27.31,
    height: 27.31,
    transform: "translate(-36.4 57.31) rotate(-13.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 322.06,
    y: 216.07,
    width: 27.31,
    height: 27.31,
    transform: "translate(-43.58 82.72) rotate(-13.2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "196.91 448.93 148.39 448.93 133.93 448.93 107.14 448.93 63.38 448.93 48.42 448.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 196.91,
    y1: 418.75,
    x2: 196.91,
    y2: 418.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "48.42 286.49 48.42 8.17 196.91 8.17 196.91 158.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 67.65,
    y: 27.83,
    width: 110.03,
    height: 85.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "177.68 158.57 177.68 133.03 67.65 133.03 67.65 218.57 141.16 218.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 177.68,
    y1: 267.94,
    x2: 177.68,
    y2: 251.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "67.65 291.99 67.65 236.39 141.16 236.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 133.93,
    y1: 321.92,
    x2: 109.86,
    y2: 321.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 177.68,
    y1: 418.75,
    x2: 177.68,
    y2: 418.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 133.93,
    y1: 341.58,
    x2: 107.14,
    y2: 341.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 113.06,
    y1: 427.11,
    x2: 86.36,
    y2: 427.11
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.74,
    y: 408.17,
    width: 6.2,
    height: 10.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 118.44,
    y: 408.5,
    width: 6.2,
    height: 10.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "408.2 283.96 422.07 283.96 422.07 267.94 126.14 267.94 126.14 283.96 393.33 283.96 405.27 283.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "464.99 175.8 497.58 175.8 497.58 8.17 357.9 8.17 357.9 175.8 437.68 175.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "283.14 109.87 266.84 109.87 213.72 109.87 213.72 7.89 311.36 7.89 311.36 79.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 437.69,
    y: 167.14,
    width: 27.31,
    height: 27.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 346.15,
    y: 308.25,
    width: 27.31,
    height: 27.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 323.95,
    y: 213.59,
    width: 27.31,
    height: 27.31,
    transform: "translate(-42.97 83.09) rotate(-13.2)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m379.57,227.24h31.01v25.19c0,8.56-6.95,15.51-15.51,15.51h0c-8.56,0-15.51-6.95-15.51-15.51v-25.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m410.58,234.95c6.22,0,10.97,1.88,10.97,7.26s-5.04,9.74-11.26,9.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m411.12,239.46c2.92,0,5.15.88,5.15,3.41s-2.37,4.58-5.29,4.58"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "407.79 353.01 407.79 448.93 393.33 448.93 393.33 388.56 393.33 283.96 405.27 283.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 407.79,
    y1: 284.01,
    x2: 407.79,
    y2: 283.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "203.28 388.56 393.33 388.56 393.33 283.96 148.39 283.96 148.39 384.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "148.39 384.03 148.39 283.96 133.93 283.96 133.93 321.92 133.93 341.58 133.93 384.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 148.39,
    y1: 448.93,
    x2: 133.93,
    y2: 448.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 133.93,
    y1: 418.75,
    x2: 133.93,
    y2: 418.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 148.39,
    y1: 418.75,
    x2: 148.39,
    y2: 418.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m253.66,251.96v15.98h116.83v-68.05c0-4.63-3.76-8.39-8.39-8.39h-75.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m237.62,251.96h39.95c4.83,0,8.74-3.91,8.74-8.73v-75.92c0-2.88-1.39-5.43-3.54-7.02h0c-1.45-1.08-3.26-1.72-5.2-1.72h-127.68c-4.82,0-8.73,3.91-8.73,8.74v75.92c0,4.82,3.91,8.73,8.73,8.73h39.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "240.5 267.94 186.97 267.94 198.71 208.18 228.77 208.18 240.5 267.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 349.85,
    y: 6.51,
    width: 25.06,
    height: 6.97,
    transform: "translate(57.64 206.35) rotate(-34.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 482.14,
    y: 9.05,
    width: 25.06,
    height: 6.97,
    transform: "translate(895.88 302.18) rotate(-145.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 349.85,
    y: 168.3,
    width: 25.06,
    height: 6.97,
    transform: "translate(564.47 518.17) rotate(-145.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 482.14,
    y: 168.3,
    width: 25.06,
    height: 6.97,
    transform: "translate(-10.6 309.3) rotate(-34.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m337.92,448.93c0-7.91-5.98-14.32-13.36-14.32s-13.36,6.41-13.36,14.32h26.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m300.36,448.93c0-7.91-5.98-14.32-13.36-14.32s-13.36,6.41-13.36,14.32h26.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m281.07,435.75c0-3.61-.05-7.2-.14-10.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m293.75,424.97c-.09,3.57-.14,7.16-.14,10.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m275.63,388.56c1.62,12.2,2.56,24.15,2.56,36.41h19.2c0-12.29.93-24.19,2.56-36.41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m318.05,435.75c0-3.61-.05-7.2-.14-10.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m330.73,424.97c-.09,3.57-.14,7.16-.14,10.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m312.61,388.56c1.62,12.2,2.56,24.15,2.56,36.41h19.2c0-12.29.93-24.19,2.56-36.41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 52.95,
    y: 327.73,
    width: 16.96,
    height: 41.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m74.41,369.83c3.5-2.59,6.83-5.58,9.51-8.93,0,0,.01-.02.01-.02.65-.81,1.27-1.65,1.83-2.51.67-1.01,1.29-2.07,1.82-3.15,1.93-3.9,3.32-8.42,4.31-13.09,3.39-16.01,2.1-33.73,2.1-33.73l-1.16-.84s-5.17,1.48-12.06,4.31c-2.33.96-4.86,2.08-7.46,3.35-2.16,1.05-4.37,2.21-6.54,3.47,1.66,6.93,2.72,14.37,2.07,21-.91,9.27-6.65,18.65-12.35,25.9l2.46.58,8.99,2.11,6.47,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m72.38,323.01l-5.57,13.69-13.43,33.02h-19.95c-2.58-7.57-4.17-15.75-3.18-23.23.25-1.87.63-3.78,1.1-5.69,1.5-6.01,4.01-12.12,6.85-17.79,1.06-2.13,2.17-4.2,3.3-6.18,2.16-3.83,4.35-7.32,6.3-10.26,3.78-5.69,6.66-9.31,6.66-9.31h1.66s4.86,6.12,10.26,14.98c.65,1.07,1.31,2.17,1.96,3.31,1.37,2.36,2.73,4.86,4.03,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m40.46,367.25l8.99-2.11,2.46-.58c-5.7-7.25-11.44-16.63-12.35-25.9-.65-6.63.41-14.07,2.07-21-2.17-1.27-4.38-2.42-6.54-3.47-2.6-1.27-5.13-2.39-7.46-3.35-6.89-2.84-12.06-4.31-12.06-4.31l-1.16.84s-1.29,17.72,2.1,33.73c1,4.67,2.38,9.19,4.31,13.09.53,1.08,1.15,2.13,1.82,3.15.57.85,1.18,1.69,1.83,2.51,0,0,.01,0,.01.02,2.68,3.35,6.01,6.34,9.51,8.93l6.47-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m44.7,369.72c-5.94-9.17-16.72-28.43-14.44-44.46,1.07-7.54,4.36-15.54,8.23-22.81,3.24-6.08,6.87-11.63,9.93-15.96,3.91-5.53,6.89-9.05,6.89-9.05h1.72s5.03,5.95,10.62,14.55c2.07,3.18,4.21,6.72,6.2,10.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m108.41,337.6c-.33,1.34-.76,2.67-1.27,3.98-3.94,10.12-12.86,19.21-20.59,25.66-1.06.88-2.09,1.7-3.08,2.48h-15.82c5.93-9.17,16.71-28.43,14.44-44.46-.68-4.8-2.27-9.79-4.33-14.66-1.17-2.78-2.51-5.51-3.91-8.15,12.67-11.33,27.56-19.2,27.56-19.2l1.59.63s6.42,19.35,6.86,38.04c.12,5.45-.26,10.84-1.45,15.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m28.87,369.72c-9.24-7.21-21.72-19.02-24.94-32.12-5.28-21.46,5.41-53.72,5.41-53.72l1.59-.64s14.89,7.87,27.56,19.21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "61.91 369.72 54.19 369.72 47.75 369.72 44.7 369.72 33.55 369.72 28.87 369.72 25.52 369.72 17.48 369.72 17.48 388.56 25.99 388.56 42.45 388.56 46.26 388.56 86.36 388.56 94.86 388.56 94.86 369.72 84.14 369.72 61.91 369.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 25.99,
    y: 388.56,
    width: 60.37,
    height: 60.37
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 122.67,
    y: 79.39,
    width: 40.97,
    height: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 126.88,
    y: 91.99,
    width: 32.54,
    height: 21.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 107.14,
    y: 430.36,
    width: 102.06,
    height: 18.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 113.06,
    y: 418.75,
    width: 92.5,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 107.14,
    y: 407.84,
    width: 104.34,
    height: 10.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 113.06,
    y: 384.03,
    width: 90.22,
    height: 16.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 116.46,
    y: 400.5,
    width: 83.42,
    height: 7.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 74.19,
    y: 58.88,
    width: 5.46,
    height: 40.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 116.52,
    y: 162.22,
    width: 5.46,
    height: 40.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 152.71,
    y: 371.93,
    width: 5.46,
    height: 40.67,
    transform: "translate(-236.82 547.71) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 151.02,
    y: 419.31,
    width: 8.84,
    height: 40.67,
    transform: "translate(-284.21 595.09) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 84.97,
    y: 254.42,
    width: 16.58,
    height: 7.3,
    transform: "translate(-77.44 43.23) rotate(-18.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 88.3,
    y: 264.29,
    width: 16.58,
    height: 7.3,
    transform: "translate(-80.42 44.8) rotate(-18.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 67.98,
    y: 152.03,
    width: 12.75,
    height: 12.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 67.82,
    y: 169.42,
    width: 12.75,
    height: 12.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 90.76,
    cy: 177.48,
    r: 3.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 90.83,
    cy: 187.6,
    r: 3.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 75.36,
    cy: 289.87,
    r: 3.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 443.57,
    y1: 175.8,
    x2: 456.11,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 443.57,
    y1: 181.56,
    x2: 458.52,
    y2: 181.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 352.65,
    y1: 318.14,
    x2: 365.19,
    y2: 318.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 352.65,
    y1: 321.9,
    x2: 361.64,
    y2: 321.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 352.65,
    y1: 325.67,
    x2: 365.19,
    y2: 325.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 222.5,
    y1: 184.11,
    x2: 234.91,
    y2: 181.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 223.57,
    y1: 188.41,
    x2: 235.98,
    y2: 185.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m382.55,40.65h2.3v8.86h9.18v-8.86h2.27v20.1h-2.27v-9.09h-9.18v9.09h-2.3v-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m407.19,61.13c-1.22,0-2.31-.34-3.27-1.02-.96-.68-1.72-1.62-2.27-2.82-.56-1.21-.83-2.59-.83-4.16,0-1.67.28-3.11.83-4.32.55-1.21,1.31-2.13,2.27-2.78.96-.65,2.05-.97,3.28-.97,1.07,0,1.99.23,2.75.7.76.47,1.37,1.1,1.83,1.9.46.8.79,1.7.97,2.71.18,1.01.23,2.05.16,3.13h-10.21v-1.54h8.69l-.68.48c.03-.63,0-1.26-.1-1.89-.09-.63-.27-1.21-.52-1.74-.26-.53-.62-.95-1.08-1.27-.46-.32-1.05-.48-1.77-.48-.91,0-1.66.25-2.27.75-.61.5-1.07,1.16-1.37,1.98-.31.82-.46,1.7-.46,2.65v1.02c0,1.07.15,2.02.45,2.86s.75,1.51,1.35,2,1.36.74,2.27.74,1.67-.24,2.26-.72.95-1.19,1.08-2.13h2.39c-.15,1.01-.48,1.89-1,2.62-.52.73-1.19,1.29-1.99,1.69-.81.39-1.72.59-2.73.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m417.45,60.75v-21.82h2.3v21.82h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m425.72,60.75v-21.82h2.3v21.82h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m439.09,61.13c-1.27,0-2.4-.3-3.39-.91-.99-.61-1.77-1.51-2.34-2.7-.57-1.19-.86-2.67-.86-4.42s.29-3.23.86-4.42c.57-1.19,1.35-2.09,2.34-2.7.99-.61,2.12-.91,3.39-.91s2.38.3,3.37.91,1.77,1.51,2.33,2.7c.57,1.19.85,2.66.85,4.42s-.28,3.22-.85,4.42c-.57,1.19-1.34,2.1-2.33,2.7-.99.61-2.11.91-3.37.91Zm-.06-2.18c.92,0,1.69-.24,2.33-.71s1.12-1.15,1.45-2.02c.33-.87.49-1.91.49-3.12,0-1.82-.35-3.26-1.05-4.31-.7-1.05-1.74-1.58-3.12-1.58-.92,0-1.71.24-2.34.71-.63.48-1.12,1.15-1.45,2.03-.33.88-.49,1.93-.49,3.14,0,1.8.35,3.23,1.05,4.28.7,1.05,1.74,1.58,3.11,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m379.98,79.05h2.6l4.81,17.89h-.68l4.93-15.81h1.57l4.87,15.68h-.65l5.52-17.76h2.57l-6.55,20.1h-2.42l-4.28-13.63h.44l-4.43,13.63h-2.42l-5.88-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m413.11,99.53c-1.27,0-2.4-.3-3.39-.91-.99-.61-1.77-1.51-2.34-2.7-.57-1.19-.86-2.67-.86-4.42s.29-3.23.86-4.42c.57-1.19,1.35-2.09,2.34-2.7.99-.61,2.12-.91,3.39-.91s2.38.3,3.37.91,1.77,1.51,2.33,2.7c.57,1.19.85,2.66.85,4.42s-.28,3.22-.85,4.42c-.57,1.19-1.34,2.1-2.33,2.7-.99.61-2.11.91-3.37.91Zm-.06-2.18c.92,0,1.69-.24,2.33-.71s1.12-1.15,1.45-2.02c.33-.87.49-1.91.49-3.12,0-1.82-.35-3.26-1.05-4.31-.7-1.05-1.74-1.58-3.12-1.58-.92,0-1.71.24-2.34.71-.63.48-1.12,1.15-1.45,2.03-.33.88-.49,1.93-.49,3.14,0,1.8.35,3.23,1.05,4.28.7,1.05,1.74,1.58,3.11,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m424.14,99.15v-15.33h2.3v15.33h-2.3Zm1.59-6.91c0-1.94.17-3.55.52-4.84.34-1.29.85-2.25,1.51-2.88.66-.63,1.47-.95,2.43-.95.32,0,.6.02.86.07.26.05.52.12.79.22l-.15,2.46c-.28-.1-.58-.18-.9-.25-.32-.07-.62-.1-.87-.1-.84,0-1.51.26-2.02.78-.51.52-.88,1.25-1.11,2.18-.23.94-.35,2.04-.35,3.31h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m434.81,99.15v-21.82h2.3v21.82h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m448.12,99.53c-1.14,0-2.19-.33-3.14-1-.96-.67-1.72-1.6-2.29-2.82-.57-1.21-.86-2.64-.86-4.28s.28-3.05.84-4.24c.56-1.19,1.31-2.11,2.24-2.76.93-.65,1.95-.97,3.06-.97,1.03,0,1.94.27,2.72.82.78.54,1.39,1.33,1.82,2.35.43,1.02.65,2.26.65,3.71h-.89c0-1.01-.18-1.87-.55-2.56s-.85-1.22-1.44-1.58c-.59-.36-1.23-.54-1.91-.54-.77,0-1.47.23-2.1.7-.63.46-1.14,1.13-1.52,1.98-.38.86-.57,1.89-.57,3.08s.19,2.26.57,3.14c.38.88.89,1.55,1.52,2.02.63.47,1.34.7,2.1.7.64,0,1.26-.18,1.85-.54.59-.36,1.08-.89,1.47-1.59.38-.7.58-1.54.58-2.54h.89c0,1.48-.22,2.74-.67,3.77-.45,1.03-1.05,1.81-1.82,2.34s-1.62.8-2.56.8Zm4.55-.38l-.38-3.58v-18.24h2.3v21.82h-1.92Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "287.46 94.62 273.37 94.62 265.55 94.62 228.32 94.62 228.32 23.14 296.76 23.14 296.76 81.69 296.76 89.29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 448.91,
    y: 327.73,
    width: 16.96,
    height: 41.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m470.36,369.83c3.5-2.59,6.83-5.58,9.51-8.93,0,0,.01-.02.01-.02.65-.81,1.27-1.65,1.83-2.51.67-1.01,1.29-2.07,1.82-3.15,1.93-3.9,3.32-8.42,4.31-13.09,3.39-16.01,2.1-33.73,2.1-33.73l-1.16-.84s-5.17,1.48-12.06,4.31c-2.33.96-4.86,2.08-7.46,3.35-2.16,1.05-4.37,2.21-6.54,3.47,1.66,6.93,2.72,14.37,2.07,21-.91,9.27-6.65,18.65-12.35,25.9l2.46.58,8.99,2.11,6.47,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m468.33,323.01l-5.57,13.69-13.43,33.02h-19.95c-2.58-7.57-4.17-15.75-3.18-23.23.25-1.87.63-3.78,1.1-5.69,1.5-6.01,4.01-12.12,6.85-17.79,1.06-2.13,2.17-4.2,3.3-6.18,2.16-3.83,4.35-7.32,6.3-10.26,3.78-5.69,6.66-9.31,6.66-9.31h1.66s4.86,6.12,10.26,14.98c.65,1.07,1.31,2.17,1.96,3.31,1.37,2.36,2.73,4.86,4.03,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m436.41,367.25l8.99-2.11,2.46-.58c-5.7-7.25-11.44-16.63-12.35-25.9-.65-6.63.41-14.07,2.07-21-2.17-1.27-4.38-2.42-6.54-3.47-2.6-1.27-5.13-2.39-7.46-3.35-6.89-2.84-12.06-4.31-12.06-4.31l-1.16.84s-1.29,17.72,2.1,33.73c1,4.67,2.38,9.19,4.31,13.09.53,1.08,1.15,2.13,1.82,3.15.57.85,1.18,1.69,1.83,2.51,0,0,.01,0,.01.02,2.68,3.35,6.01,6.34,9.51,8.93l6.47-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m440.66,369.72c-5.94-9.17-16.72-28.43-14.44-44.46,1.07-7.54,4.36-15.54,8.23-22.81,3.24-6.08,6.87-11.63,9.93-15.96,3.91-5.53,6.89-9.05,6.89-9.05h1.72s5.03,5.95,10.62,14.55c2.07,3.18,4.21,6.72,6.2,10.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m504.37,337.6c-.33,1.34-.76,2.67-1.27,3.98-3.94,10.12-12.86,19.21-20.59,25.66-1.06.88-2.09,1.7-3.08,2.48h-15.82c5.93-9.17,16.71-28.43,14.44-44.46-.68-4.8-2.27-9.79-4.33-14.66-1.17-2.78-2.51-5.51-3.91-8.15,12.67-11.33,27.56-19.2,27.56-19.2l1.59.63s6.42,19.35,6.86,38.04c.12,5.45-.26,10.84-1.45,15.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m424.83,369.72c-9.24-7.21-21.72-19.02-24.94-32.12-5.28-21.46,5.41-53.72,5.41-53.72l1.59-.64s14.89,7.87,27.56,19.21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "457.87 369.72 450.15 369.72 443.71 369.72 440.66 369.72 429.51 369.72 424.83 369.72 421.48 369.72 413.44 369.72 413.44 388.56 421.95 388.56 438.41 388.56 442.22 388.56 482.32 388.56 490.82 388.56 490.82 369.72 480.1 369.72 457.87 369.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 421.95,
    y: 388.56,
    width: 60.37,
    height: 60.37
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 244.85,
    cy: 39.1,
    rx: 1.11,
    ry: 1.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 256.3,
    y1: 79.96,
    x2: 261.82,
    y2: 79.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m280.63,69.02s1.37,5.39,1.16,6.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m256.3,35c.48.21,1,.42,1.56.63,6.78,2.54,6.49,10.17,6.49,10.17,0,0,.57,5.36,1.84,8.29s5.51,5.26,10.59,8.88c2.38,1.7,3.6,4.75,4.23,7.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "250.73 33.08 253.18 28.36 254.45 28.36 256.83 35.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m289.14,73.26c1,2.75.65,8.25-.8,9.1s-5.82,2.54-5.82,2.54h-27.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m256.83,71.43l-1.51,13.48h-8.05s-3.53-1.75-2.42-3.16,3.69-3.03,3.69-3.03l-1.13-5.22c-2.54-4.68-5.08-5.5-9.03-11.33-3.95-5.82,2.54-14.52,2.54-14.52,0,0-3.95-.83-5.36-2.47-1.42-1.66,0-6.07,0-6.07h5.36s.56-4.38,5.04-6.58c2.2-1.08,3.47-.96,5-.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m281.01,68.02s2.79-3.68,5.72.45,2.92,7.54,2.92,7.54"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m286.31,191.5v-24.19c0-2.88-1.39-5.43-3.54-7.02h0c2.43-.74,4.89-1.36,7.45-1.72,0,0,15.24,16.36,28.69.09.12.02.24.04.36.06,4.1.76,7.96,2.28,11.89,3.77,4.02,1.52,8.19,2.89,11.65,5.72,3.37,2.75,5.81,6.69,7.54,10.9,1.48,3.59,3.14,8.04,3.86,12.39h-67.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m342.55,135.95c.03,3.06-.12,6.15-.53,9.18-.23,1.61-.39,3.93-1.4,5.25-1.88,2.43-5.09,2.21-5.09,2.21,0,0-12.72,1.22-16.11-1.92-1.42-1.32-4.59-1.43-8.2-1.02-.33-3.01.08-5.8.22-6.63-1.97,1.01-4.15,1.56-6.54,1.56-2.58,0-4.96-.64-7.09-1.79.07.38,1.09,5.38-.32,9.68-.18.04-.34.08-.5.12-5.63,1.35-8.39,0-8.39,0,0,0-5.93.36-10.22-3.36-2.8-2.43-5.72-2.46-9.07-1.82-1.65-5.26-2.29-10.88-1.88-16.41.2-2.76.7-5.6,2.2-7.86,1.07-1.62,2.63-2.87,4.39-3.51,1.54-.57,3.25-.68,4.71-1.48,2.34-1.29,3.58-4.11,4.15-6.85.25-1.2.41-2.42.54-3.66.38-3.57.54-7.2,2.15-10.32,1.28-2.49,3.39-4.4,5.7-5.81,4.99-3.04,10.55-3.35,15.69-1.29-.68-1.98-.66-4.17.2-6.15,1.85-4.21,6.84-5.89,11.17-3.76,4.31,2.14,6.32,7.28,4.47,11.49-.23.55-.53,1.05-.87,1.51,2.47.75,4.35,2.37,6.01,4.34,1.85,2.18,3.42,4.8,5.25,7.18,2.43,3.17,3.92,6.58,5,10.49,1.96,7.02,4.27,13.18,4.36,20.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m286.2,120.28c-3.37-2.08-4.52,2.59-3.86,5.14s2.92,4.16,5.05,3.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m323.37,120.28c3.37-2.08,4.52,2.59,3.86,5.14s-2.92,4.16-5.05,3.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m296.32,115.03l23.43-1.53h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m322.68,113.94s.01.06.02.09c.5,1.87.73,3.82.65,5.81v.07c-.02.58-.07,1.15-.15,1.74-.11.8-.24,1.59-.4,2.37v.02c-1.61,8.57-5.54,15.81-11.36,18.89-.92.5-1.89.89-2.91,1.16-.34.09-.68.16-1.03.24-.24.04-.47.08-.71.11-.13.02-.25.03-.38.04-.2.02-.41.04-.62.05-.29.02-.59.03-.89.03-.64,0-1.28-.04-1.9-.12-.23-.03-.46-.07-.69-.11-1.59-.29-3.1-.86-4.5-1.65h0c-6.21-3.53-10.32-11.64-11.21-21.04-.18-1.86-.11-3.68.18-5.43,0-.05.01-.1.02-.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m297.8,142.77h.01v.02c.07.38,1.09,5.38-.32,9.68-.93,2.84-2.92,5.37-6.93,6.05-.11.02-.22.03-.34.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m285.74,116.74s5.22.89,9.69-1.26,5.73-6.35,9.29-7.68,7.23-2.07,7.23-2.07c0,0,1.84,6.13,11.42,8.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m311.49,142.77s-.02.09-.05.25c-.14.83-.55,3.62-.22,6.63.41,3.89,2.06,8.14,7.14,8.92l.18.03c.12.02.25.04.37.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m301.73,135.04s.64,1.01,2.71,1.18,3.33-1.18,3.33-1.18"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 312.61,
    cy: 121.44,
    rx: 1.51,
    ry: 2.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 296.86,
    cy: 120.89,
    rx: 1.51,
    ry: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m304.75,122.94s-.15,4.09-1.81,4.64.9,2.88.9,2.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.36,79.39c-.31-2.25-.47-4.59-.47-7,0-16.73,7.73-30.29,17.26-30.29s17.26,13.56,17.26,30.29c0,2.41-.16,4.75-.47,7h-33.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 136.06,
    y1: 48.86,
    x2: 129.32,
    y2: 42.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.15,
    y1: 58.88,
    x2: 146.61,
    y2: 48.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 136.06,
    y1: 70.6,
    x2: 132.69,
    y2: 62.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 154.8,
    y1: 66.49,
    x2: 163.64,
    y2: 58.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 129.32,
    y1: 70.6,
    x2: 121.9,
    y2: 62.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 144.88,
    y1: 74.14,
    x2: 148.39,
    y2: 66.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 152.71,
    y1: 54.86,
    x2: 156.89,
    y2: 48.86
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 67.65,
    y: 45.07,
    width: 24,
    height: 68.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 91.65,
    y: 54.86,
    width: 13.08,
    height: 58.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 67.65,
    y: 142.53,
    width: 13.08,
    height: 76.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 80.74,
    y: 150.93,
    width: 20.06,
    height: 67.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 100.92,
    y: 158.52,
    width: 10.03,
    height: 60.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 110.95,
    y: 144.58,
    width: 16.59,
    height: 73.99
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "67.65 291.99 67.65 257.2 84.24 257.2 84.24 294.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "94.83 287.06 80.9 247.04 96.57 241.59 124.46 321.7 123.83 321.92"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 329.92,
    y1: 224.6,
    x2: 343.55,
    y2: 221.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 330.85,
    y1: 228.6,
    x2: 342.62,
    y2: 225.89
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIllustration);
export default __webpack_public_path__ + "static/media/portfolio-illustration.b44dab1f5595daf9f1e392547f054892.svg";
export { ForwardRef as ReactComponent };